module.exports = __webpack_public_path__ + "static/img/work1.b5dd7687.png";